import { render, staticRenderFns } from "./zysy.vue?vue&type=template&id=3f041150&scoped=true"
import script from "./zysy.vue?vue&type=script&lang=js"
export * from "./zysy.vue?vue&type=script&lang=js"
import style0 from "./zysy.vue?vue&type=style&index=0&id=3f041150&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f041150",
  null
  
)

export default component.exports